import type { RequestOptions } from "../common/server";
import type { FilesystemJs, PublicTemplatesListingJs, TemplateInfoJs } from "@/generated/models";
import { server } from "./server";

export async function getSharedAssetsFilesystems(organizationId: string, { signal }: RequestOptions = {}) {
  const searchParams = {
    organizationId,
  };
  const response = await server.get(`templates/organizations/${organizationId}/filesystems`, { searchParams, signal });
  return await response.json() as FilesystemJs[];
}

export async function getOrganizationLibraries(organizationId: string, { signal }: RequestOptions = {}) {
  const searchParams = {
    organizationId,
  };
  const response = await server.get(`templates/libraries/organizations/${organizationId}`, { searchParams, signal });
  return await response.json() as TemplateInfoJs[];
}

export async function getPublicLibraries({ signal }: RequestOptions = {}) {
  const response = await server.get("templates/libraries/public", { signal });
  return await response.json() as TemplateInfoJs[];
}

export async function getOrganizationTemplates(organizationId: string, { signal }: RequestOptions = {}) {
  const searchParams = {
    organizationId,
  };
  const response = await server.get(`templates/organizations/${organizationId}`, { searchParams, signal });
  return await response.json() as TemplateInfoJs[];
}

export async function getPublicTemplates({ signal }: RequestOptions = {}) {
  const response = await server.get("templates/public", { signal });
  return await response.json() as PublicTemplatesListingJs;
}

export async function hasAnyLibraryFile(organizationId: string, { signal }: RequestOptions = {}) {
  const searchParams = {
    organizationId,
  };
  const response = await server.get(`templates/libraries/organizations/${organizationId}/has-files`, { searchParams, signal });
  return await response.json() as boolean;
}
